module.exports = __webpack_public_path__ + "img/wenjiang2.d6784dd8.png";